import { FC, ReactNode } from 'react'

import { cn } from '@bem-react/classname'
import { AnimatePresence, motion } from 'framer-motion'

import './Message.scss'

interface IMessageProps {
  className?: string
  text: ReactNode
  type?: 'error' | 'success' | 'info'
  open?: boolean
}

const cnMessage = cn('Message')

export const Message: FC<IMessageProps> = ({ className, text, type, open }) => {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          className={cnMessage(
            {
              error: type === 'error',
              success: type === 'success',
              info: type === 'info',
            },
            [className],
          )}
        >
          {type === 'error' && <span className={cnMessage('icon')}>🥵</span>}
          {type === 'success' && <span className={cnMessage('icon')}>👍</span>}
          {type === 'info' && <span className={cnMessage('icon')}>👉</span>}
          {text}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
